import React, { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import FloatingEmojis from '../components/FloatingEmojis'
import { Loader2 } from 'lucide-react'
import { Link } from 'react-router-dom'

const LoginPage = () => {
  const { signInWithGoogle } = useAuth()
  const [isLoading, setIsLoading] = useState(false)

  const handleGoogleSignIn = async () => {
    setIsLoading(true)
    try {
      await signInWithGoogle()
    } catch (error) {
      console.error('Sign in error:', error)
      alert('Failed to sign in. Please try again.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center relative overflow-hidden">
      <FloatingEmojis />
      
      <div className="relative z-10 text-center max-w-md mx-auto px-6">
        {/* Logo and Title */}
        <div className="mb-8">
          <div className="text-6xl mb-4 animate-bounce-slow">🧠</div>
          <h1 className="text-4xl font-bold text-gray-800 mb-2">
            Strangeminder
          </h1>
          <p className="text-lg text-gray-600">
            Let someone else give you a reason.
          </p>
        </div>

        {/* Login Card */}
        <div className="card bg-white/90 backdrop-blur-sm">
          <div className="mb-6">
            <h2 className="text-2xl font-semibold text-gray-800 mb-2">
              Welcome!
            </h2>
            <p className="text-gray-600">
              Sign in to start creating and rewriting reminders with strangers.
            </p>
          </div>

          <button
            onClick={handleGoogleSignIn}
            disabled={isLoading}
            className="btn-primary w-full flex items-center justify-center space-x-3 disabled:opacity-50 disabled:cursor-not-allowed hover:scale-105 transition-transform"
          >
            {isLoading ? (
              <Loader2 className="animate-spin" size={20} />
            ) : (
              <>
                <svg className="w-5 h-5" viewBox="0 0 24 24">
                  <path
                    fill="currentColor"
                    d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                  />
                  <path
                    fill="currentColor"
                    d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                  />
                  <path
                    fill="currentColor"
                    d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                  />
                  <path
                    fill="currentColor"
                    d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                  />
                </svg>
                <span>Continue with Google</span>
              </>
            )}
          </button>

          <div className="mt-6 text-sm text-gray-500">
            <p>By signing in, you agree to our</p>
            <p>
              <Link to="/terms" className="text-primary-600 hover:underline">
                Terms of Service
              </Link>{' '}
              and{' '}
              <Link to="/privacy" className="text-primary-600 hover:underline">
                Privacy Policy
              </Link>
            </p>
          </div>
        </div>

        {/* Features Preview */}
        <div className="mt-8 grid grid-cols-1 gap-4 text-sm text-gray-600">
          <div className="flex items-center justify-center space-x-2">
            <span className="text-xl">✨</span>
            <span>Create short reminders</span>
          </div>
          <div className="flex items-center justify-center space-x-2">
            <span className="text-xl">💭</span>
            <span>Get creative rewrites from strangers</span>
          </div>
          <div className="flex items-center justify-center space-x-2">
            <span className="text-xl">🏆</span>
            <span>Earn achievements and badges</span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoginPage 